<template>
        <b-form ref="projectform" class="h-100">
            
            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                        <template slot="label">
                            <span v-translate>Customer or Supplier</span>
                        </template>
                        <b-input-group>
                            <b-form-input id="input-1" type="text" v-model="contactName" :disabled="true"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label" label-for="input-2">
                        <template slot="label">
                            <span v-translate>Project name*</span>
                        </template>
                        <b-input-group>
                            <b-form-input id="input-2" type="text" v-model="projectDetails.name" :required="true" placeholder="Project_01"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-3" label-class="gk-label-margin gk-modal-label" label-for="input-3">
                        <template slot="label">
                            <span v-translate>Project contact name</span>
                        </template>
                        <b-input-group>
                            <b-form-input id="input-3" type="text" v-model="projectDetails.contact_name" :placeholder="$gettext('John Doe')"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label" label-for="input-4">
                        <template slot="label">
                            <span v-translate>Project reference</span>&nbsp;
                            <font-awesome-icon 
                                id="tt_project_reference"
                                icon="fa-solid fa-circle-info"
                                class="text-info"
                            />
                            <b-tooltip target="tt_project_reference" triggers="hover">
                                {{ $gettext('A project code or reference. Shown on invoices if present.') }}
                            </b-tooltip>
                        </template>
                        <b-input-group>
                            <b-form-input id="input-4" type="text" v-model="projectDetails.reference" :placeholder="$gettext('Purchase order 1234')"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
                        <template slot="label">
                            <span v-translate>Notes</span>&nbsp;
                            <font-awesome-icon 
                                id="tt_project_notes"
                                icon="fa-solid fa-circle-info"
                                class="text-info"
                            />
                            <b-tooltip target="tt_project_notes" triggers="hover">
                                {{ $gettext('Project notes are private and will only ever be visible to you.') }}
                            </b-tooltip>
                        </template>
                        <b-input-group>
                            <b-form-textarea id="input-5" type="text" v-model="projectDetails.description" :placeholder="$gettext('Here you can input any details about this project you want to remember.')" rows="6"></b-form-textarea>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-6" label-class="gk-label-margin gk-modal-label" label-for="input-6">
                        <template slot="label">
                            <span v-translate>Default hourly rate (Ex. VAT)</span> <!-- EURO -->
                        </template>
                        <b-input-group>
                            <template #append>
                                <b-input-group-text><span>€</span></b-input-group-text>
                            </template>
                            <b-form-input id="input-6" type="number" step=".01" min="0" v-model="projectDetails.hourly_rate" placeholder="0"></b-form-input>
                            
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-7" label-class="gk-label-margin gk-modal-label" label-for="input-7">
                        <template slot="label">
                        </template>
                        <b-input-group>
                            <b-form-checkbox
                                id="input-7"
                                :value="true"
                                :unchecked-value="false"
                                v-model="projectDetails.favorite"
                                switch>
                                <span v-translate>Favorite project</span>&nbsp;
                                <font-awesome-icon 
                                    id="tt_project_favorite"
                                    icon="fa-solid fa-circle-info"
                                    class="text-info"
                                />
                                <b-tooltip target="tt_project_favorite" triggers="hover">
                                    {{ $gettext('Showed project on top in the hours add page, for fast daily use.') }}
                                </b-tooltip>
                            </b-form-checkbox>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

        </b-form>
           
</template>

<script>
import ProjectService from "@/store/services/project.service";
import CustomerService from "@/store/services/customer.service";
import { mapMutations } from "vuex";

export default {
    name: "AddEditProject",
    components: {},
    props: {
        projectDetails: {
            type: Object,
            default() {
                return {
                    company: null,
                    name: "",
                    contact_name: null,
                    reference: "",
                    description: "",
                    hourly_rate: null,
                    favorite: false,
                }
            }
        },
        projectData: {
            type: Number,
            default: null
        },
        contactData: {
            type: Number,
            default: null
        }
    },
    watch: {
        contactData(val) {
            this.contactId = val
            this.getContactData(this.contactId)
            // console.log('CONTACT DATA: ' + this.contactId)
        }
    },
    data() {
        return {
            projectId: null,
            contactId: null,
            contactName:'',
        }
    },
    created() {
        // console.log('addEditCreated')
        this.projectId = this.$route.params['projectId'] || this.projectData;
        this.contactId = this.$route.params['contactId'] || this.contactData;
        if(this.contactId) {
            this.getContactData(this.contactId)
        }
    },
    methods: {
        ...mapMutations({
            setWaitingForResponse: 'main/SET_WAITING_FOR_RESPONSE'
        }),
        getContactData (contact_id) {
            CustomerService.retrieve(contact_id).then((response) => {
                this.contactName = response.data.name;
            });
            if (this.contactId) { // add
                this.projectDetails.company = this.contactId;
            }
        },
        saveForm() {
            if(!this.$refs.projectform.reportValidity())
                return false

            this.setWaitingForResponse(true)

            if (this.projectId) { // edit
                ProjectService.update(this.projectId, this.projectDetails).then((response) => {
                    this.$emit('updated', response.data);
                    this.$store.commit('setAlert', {
                        title: this.$gettext("Project updated"),
                        text: this.$gettext("Project updated correctly."),
                        variant: "success",
                        duration: 4
                    });
                }).catch((error) => {
                    let msg = this.$gettext('The project could not be updated');
                    if (error.data) {
                        let firstDictKey = Object.keys(error.data)[0];
                        msg = error.data[firstDictKey];
                    }
                    this.$store.commit('setAlert', {
                        title: this.$gettext("Error updating project"),
                        text: msg,
                        variant: "danger",
                        duration: 4
                    });
                }).finally(() => {
                    this.setWaitingForResponse(false)
                });
            } else if (this.contactId) { // add
                ProjectService.create(this.projectDetails).then((response) => {
                    this.$emit('created', response.data);
                    this.$store.commit('setAlert', {
                        title: this.$gettext("Project created"),
                        text: this.$gettext("Project added to the projects list."),
                        variant: "success",
                        duration: 4
                    });
                }).catch((error) => {
                    let msg = this.$gettext('The project could not be added to the list.');
                    if (error.data) {
                        let firstDictKey = Object.keys(error.data)[0];
                        msg = error.data[firstDictKey];
                    }
                    this.$store.commit('setAlert', {
                        title: this.$gettext("Error adding project"),
                        text: msg,
                        variant: "danger",
                        duration: 4
                    });
                }).finally(() => {
                    this.setWaitingForResponse(false)
                });
            }
        }
    },
    computed: {
        contactSelectDisabled() {
            return true;
        }
    }
}
</script>

<style scoped>
.blue-info {
    color: #457cce;
}

.form-element {
    display: inline-block;
    padding: 20px;
}

.action-button {
    display: inline-block;
    padding: 10px;
}

.help-text {
    color: #888;
    font-size: 14px;
}
</style>